import './AccordionsPage.scss';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import AppAccordion from '../AppAccordion/AppAccordion';
import CodeSnippet from '../CodeSnippet/CodeSnippet';
import parse, {
  domToReact,
  HTMLReactParserOptions,
  Element,
  DOMNode
} from 'html-react-parser';
import ReactDOMServer from 'react-dom/server';

const AccordionsPage = ({ accordions }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const key = JSON.stringify(accordions);

  const convertTableToMobileView = (htmlString: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    const headers = Array.from(doc.querySelectorAll('thead th')).map((th) =>
      th.textContent?.trim()
    );
    const rows = doc.querySelectorAll('tbody tr');

    let mobileViewHtml = Array.from(rows)
      .map((row) => {
        const cells = row.querySelectorAll('td');
        let rowHtml = '<div class="mobile-row">';

        cells.forEach((cell, index) => {
          rowHtml += `
          <div class="mobile-subrow">
            <p class="mobile-subrow-header">${headers[index]}</p>
            <p>${cell.textContent?.trim()}</p>
          </div>
        `;
        });

        rowHtml += '</div>';
        return rowHtml;
      })
      .join('');

    mobileViewHtml = `<div class="mobile-table-view">${mobileViewHtml}</div>`;

    const tableElement = doc.querySelector('table');
    if (tableElement) {
      tableElement.outerHTML = mobileViewHtml;
    }

    return doc.body.innerHTML;
  };

  const getAccordionDetails = (accordion) => {
    if (accordion.sub_accordions && accordion.sub_accordions.length > 0) {
      return accordion.sub_accordions.map((subAccordion) => (
        <Box mb={1.25} sx={{ background: 'white !important' }} className="sub-accordion">
          <AppAccordion
            key={subAccordion.id}
            details={getAccordionDetails(subAccordion)}
            summary={subAccordion.summary}
          />
        </Box>
      ));
    }
    if (isMobile) {
      return convertTableToMobileView(transformPreTag(accordion.details));
    }
    return transformPreTag(accordion.details);
  };

  const transformPreTag = (htmlString: string) => {
    const transformedHtmlString = htmlString.replace(
      /<pre>([\s\S]*?)<\/pre>/g,
      (_, p1) => `<codesnippet>${p1}</codesnippet>`
    );

    const options: HTMLReactParserOptions = {
      replace: (node) => {
        if (
          node instanceof Element &&
          node.tagName.toLowerCase() === 'codesnippet'
        ) {
          const content = domToReact(node.children as DOMNode[]);
          return <CodeSnippet>{content}</CodeSnippet>;
        }
      }
    };

    const reactElement = parse(transformedHtmlString, options);

    return ReactDOMServer.renderToStaticMarkup(
      reactElement as React.ReactElement
    );
  };

  return (
    <div className="accordions-page" key={key}>
      {Array.isArray(accordions) ? (
        accordions.map((accordion) => (
          <AppAccordion
            key={accordion.id}
            details={getAccordionDetails(accordion)}
            summary={accordion.summary}
          />
        ))
      )
        : (
          <div dangerouslySetInnerHTML={{ __html: accordions }}></div>
        )
      }
    </div>
  );
};

export default AccordionsPage;
